import type { AppRouteModule } from "/@/router/types";

import { LAYOUT } from "/@/router/constant";

const keywordRouter: AppRouteModule = {
  path: "/keyword",
  name: "keyword",
  component: LAYOUT,
  redirect: "/keyword/index",
  meta: {
    hideChildrenInMenu: false,
    icon: "ant-design:home-outlined",
    title: "关键字",
    orderNo: 2,
  },
  children: [
    {
      path: "index",
      name: "KeywordIndex",
      component: () => import("/@/views/keyword/index.vue"),
      meta: {
        title: "关键字",
        hideMenu: false,
      },
    },
    {
      path: "content",
      name: "KeywordContent",
      component: () => import("/@/views/keyword/content.vue"),
      meta: {
        title: "内容关键字",
        hideMenu: false,
      },
    },
  ],
};

export default keywordRouter;
